<template>
  <layout-bigscreen nav_top="0">
    <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" class="zoom_bg_color"
      style="width:100%; height:100%;">
      <div class="antdVue" :style="{...calculateStyles}">

        <div class="flex flex-direction justify-center benben-flex-layout yonghuhuaxiang_597_random_flex_0 w-100">
          <div
            class="flex flex-wrap align-center justify-center yonghuhuaxiang_271_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto">
            <div class="flex  flex-wrap align-center yonghuhuaxiang_447_fd0_0_c0 position-absolute"
              v-if="!isEmpty(weather_info.text)">
              <img class="yonghuhuaxiang_314_fd0_0_c0_c0" :src="weather_info.img_url" />

              <span class="yonghuhuaxiang_468_fd0_0_c0_c1 t-20 t-w-4">{{weather_info.text}}</span>
              <div class="flex  flex-wrap align-center yonghuhuaxiang_624_fd0_0_c0_c2 bg-size-auto">

              </div>
              <span class="yonghuhuaxiang_991_fd0_0_c0_c3 t-20 h-10-px t-w-4">{{weather_info.temperature}}</span>
              <span class="yonghuhuaxiang_799_fd0_0_c0_c4 f-c-fff t-20 t-w-5 h-10-px">℃</span>

            </div>
            <img class='yonghuhuaxiang_767_fd0_0_c1'
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png" />
            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">用户画像大屏</span>
            <img class='yonghuhuaxiang_311_fd0_0_c3'
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png" />
            <div class="flex align-center yonghuhuaxiang_868_fd0_0_c4 position-absolute">
              <img class='yonghuhuaxiang_424_fd0_0_c4_c0'
                src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png" />

              <benben-real-time
                class='flex align-center justify-center yonghuhuaxiang_642_random_fd0_0_c4_c1 t-18 t-w-4'
                format="YYYY-MM-DD HH:mm:ss" :has_week="true" :refresh_interval="500" show_title="true"
                title_position="left" title_name="标题">

              </benben-real-time>


            </div>

            <benben-full-screen
              class='flex align-center justify-center yonghuhuaxiang_517_random_fd0_0_c5 position-absolute a'>

            </benben-full-screen>


          </div>

          <a-row class="benben-grid   w-100" :gutter="[8,8]" type="flex">

            <a-col :xs="24" :md="6" :xl="6" :xxl="6">
              <div class="flex  flex-wrap align-center  pd-t-0 pd-r-0 pd-b-0 pd-l-10 w-100">
                <div
                  class="flex flex-direction align-start yonghuhuaxiang_353_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto">
                  <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-22 t-w-5">
                    <span>当前统计数据</span>

                  </div>
                  <img class='yonghuhuaxiang_694_fd0_1_c0_c0_c0_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <div class="flex align-center  w-100">
                      <div
                        class="flex flex-direction align-center justify-center yonghuhuaxiang_324_fd0_1_c0_c0_c0_c2_c0_c0 w-80-px bg-size-auto">
                        <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">用户总数</span>

                        <benben-light-text
                          class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                          :field-options="userCount" data_source_type="1" chart_show_type="simple-text"
                          :is_abs="false">

                        </benben-light-text>


                      </div>
                      <div
                        class="flex flex-direction align-center justify-center yonghuhuaxiang_324_fd0_1_c0_c0_c0_c2_c0_c0 w-80-px bg-size-auto">
                        <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">未成单用户数</span>

                        <benben-light-text
                          class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                          :field-options="field_options_511407" data_source_type="1" chart_show_type="simple-text"
                          :is_abs="false">

                        </benben-light-text>


                      </div>
                      <div
                        class="flex flex-direction align-center justify-center yonghuhuaxiang_324_fd0_1_c0_c0_c0_c2_c0_c0 w-80-px bg-size-auto">
                        <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">总下单用户数</span>

                        <benben-light-text
                          class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                          :field-options="orderUserCount" data_source_type="1" chart_show_type="simple-text"
                          :is_abs="false">

                        </benben-light-text>


                      </div>
                      <div
                        class="flex flex-direction align-center justify-center yonghuhuaxiang_324_fd0_1_c0_c0_c0_c2_c0_c0 w-80-px bg-size-auto">
                        <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">近7天下单</span>

                        <benben-light-text
                          class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                          :field-options="orderUserCount7" data_source_type="1" chart_show_type="simple-text"
                          :is_abs="false">

                        </benben-light-text>


                      </div>
                      <div
                        class="flex flex-direction align-center justify-center yonghuhuaxiang_484_fd0_1_c0_c0_c0_c2_c0_c4 w-80-px bg-size-auto">
                        <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">近14天下单</span>

                        <benben-light-text
                          class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                          :field-options="orderUserCount14" data_source_type="1" chart_show_type="simple-text"
                          :is_abs="false">

                        </benben-light-text>


                      </div>

                    </div>
                    <div class="flex  flex-wrap align-center  w-100">
                      <div class="flex align-center  w-100">
                        <div
                          class="flex flex-direction align-center justify-center yonghuhuaxiang_979_fd0_1_c0_c0_c0_c2_c1_c0_c0 w-80-px bg-size-auto">
                          <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">近30天下单</span>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                            :field-options="orderUserCount30" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>
                        <div
                          class="flex flex-direction align-center justify-center yonghuhuaxiang_979_fd0_1_c0_c0_c0_c2_c1_c0_c0 w-80-px bg-size-auto">
                          <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">余额大于0</span>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                            :field-options="userBalance0" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>
                        <div
                          class="flex flex-direction align-center justify-center yonghuhuaxiang_979_fd0_1_c0_c0_c0_c2_c1_c0_c0 w-80-px bg-size-auto">
                          <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">余额大于50</span>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                            :field-options="userBalance50" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>
                        <div
                          class="flex flex-direction align-center justify-center yonghuhuaxiang_979_fd0_1_c0_c0_c0_c2_c1_c0_c0 w-80-px bg-size-auto">
                          <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">余额大于100</span>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                            :field-options="userBalance100" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>
                        <div
                          class="flex flex-direction align-center justify-center yonghuhuaxiang_950_fd0_1_c0_c0_c0_c2_c1_c0_c4 mg-0 w-80-px bg-size-auto">
                          <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-12 t-w-5">余额大于500</span>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-18 f-c-6'
                            :field-options="userBalance500" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>

                      </div>

                    </div>

                  </div>

                </div>
                <div
                  class="flex flex-direction align-start yonghuhuaxiang_157_fd0_1_c0_c0_c1 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto">
                  <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-22 t-w-5">
                    <span>性别和年龄</span>

                  </div>
                  <img class='yonghuhuaxiang_661_fd0_1_c0_c0_c1_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex align-center justify-around yonghuhuaxiang_180_fd0_1_c0_c0_c1_c2 w-100">

                    <benben-pie-base class='yonghuhuaxiang_978_random_fd0_1_c0_c0_c1_c2_c0 w-50'
                                     :field-options="userSexPie" data_source_type="1" chart_show_type="pie-base"
                                     show_title="false" title_position="middle" title_name="性别" :open_drill="true"
                                     :chart_drill="{'aid':'447','name':'用户性别分析折线图','charts_type':'line','chart_show_type':'line-simple','chart_source_type':1}"
                                     :theme_color="theme_color_1601" :chart-option="chartOptions_random_6717">

                    </benben-pie-base>
                    <benben-pie-base class='yonghuhuaxiang_978_random_fd0_1_c0_c0_c1_c2_c0 w-50'
                                     :field-options="userAgePie" data_source_type="1" chart_show_type="pie-base"
                                     show_title="false" title_position="middle" title_name="累计用户注册占比" :open_drill="true"
                                     :chart_drill="{'aid':'450','name':'用户注册类型柱状图分析','charts_type':'bar','chart_show_type':'bar-base','chart_source_type':1}"
                                     :theme_color="theme_color_1354" :chart-option="chartOptions_random_8861">

                    </benben-pie-base>


                  </div>
                  <div
                    class="flex flex-wrap align-center justify-around yonghuhuaxiang_615_fd0_1_c0_c0_c1_c3 w-100 f-c-3 t-16">
                    <span>性别</span>
                    <span>年龄</span>

                  </div>

                </div>
                <div class="flex flex-direction align-start yonghuhuaxiang_138_fd0_1_c0_c0_c2 w-100 bg-size-auto">
                  <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-22 t-w-5">
                    <span>注册曲线图</span>

                  </div>
                  <img class='yonghuhuaxiang_694_fd0_1_c0_c0_c0_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex  flex-wrap align-center  w-100 h-100">

                    <benben-line-area-accumul class='w-100 h-100' :field-options="userAxis"
                      data_source_type="1" chart_show_type="line-area-accumul" show_title="false" title_position="left"
                      title_name="标题"
                      :linear_gradient_color="[{'start':10,'color1':'rgba(17, 246, 242, 0)','color2':'rgba(17, 246, 242, 0.64)'}]"
                      :theme_color="theme_color_3723" :chart-option="chartOptions_random_3145">

                    </benben-line-area-accumul>


                  </div>

                </div>

              </div>

            </a-col>


            <a-col :xs="24" :md="12" :xl="12" :xxl="12">
              <div
                class="flex flex-direction align-end yonghuhuaxiang_940_fd0_1_c1_c0 pd-t-0 pd-r-0 pd-b-10 pd-l-0 w-100">
                <div class="flex flex-direction align-center yonghuhuaxiang_374_fd0_1_c1_c0_c0 w-100 position-relative">

                  <benben-multi-level-map class='yonghuhuaxiang_461_random_fd0_1_c1_c0_c0_c0 w-100'
                                          :field-options="userAddressMap" data_source_type="1" chart_show_type="area-map"
                                          show_title="false" title_position="middle" title_name="标题" unit="" :hidden_south_lands="false">

                  </benben-multi-level-map>


                </div>
                <div
                  class="flex flex-direction flex-wrap align-stretch yonghuhuaxiang_481_fd0_1_c1_c0_c1 w-100 bg-size-auto">
                  <div class="flex flex-wrap align-center justify-center  w-100 f-c-3 t-22 t-w-5">
                    <span>用户标签排行</span>

                  </div>
                  <img class='yonghuhuaxiang_661_fd0_1_c0_c0_c1_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex align-center flex-sub yonghuhuaxiang_765_fd0_1_c1_c0_c1_c2 w-100">

                    <benben-bar-base class='w-100 h-100' :field-options="field_options_906788" data_source_type="1"
                      chart_show_type="bar-base" show_title="false" title_position="middle" title_name="标题"
                      :theme_color="theme_color_1600" :chart-option="chartOptions_random_3480">

                    </benben-bar-base>


                  </div>

                </div>

              </div>

            </a-col>


            <a-col :xs="24" :md="6" :xl="6" :xxl="6">
              <div class="flex  flex-wrap align-center  w-100">
                <div
                  class="flex flex-direction align-start yonghuhuaxiang_353_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto">
                  <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-20 t-w-5">
                    <span>消费用户统计</span>

                  </div>
                  <img class='yonghuhuaxiang_694_fd0_1_c0_c0_c0_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <div class="flex  flex-wrap align-center  w-100">
                      <div class="flex align-center yonghuhuaxiang_844_fd0_1_c2_c0_c0_c2_c0_c0 w-100">
                        <div
                          class="flex align-center justify-between yonghuhuaxiang_429_fd0_1_c2_c0_c0_c2_c0_c0_c0 bdr-8">
                          <div class="flex  flex-wrap align-center yonghuhuaxiang_337_fd0_1_c2_c0_c0_c2_c0_c0_c0_c0">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费0-100：</span>

                          </div>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_561_random_fd0_1_c2_c0_c0_c2_c0_c0_c0_c1 t-24'
                            :field-options="payAmountUserCount100" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>
                        <div
                          class="flex flex-wrap align-center justify-between yonghuhuaxiang_241_fd0_1_c2_c0_c0_c2_c0_c0_c1 bdr-8">
                          <div class="flex  flex-wrap align-center yonghuhuaxiang_337_fd0_1_c2_c0_c0_c2_c0_c0_c0_c0">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费100-500：</span>

                          </div>

                          <benben-light-text
                            class='light-text yonghuhuaxiang_561_random_fd0_1_c2_c0_c0_c2_c0_c0_c0_c1 t-24'
                            :field-options="payAmountUserCount500" data_source_type="1" chart_show_type="simple-text"
                            :is_abs="false">

                          </benben-light-text>


                        </div>

                      </div>
                      <div class="flex align-center yonghuhuaxiang_844_fd0_1_c2_c0_c0_c2_c0_c0 w-100">
                        <div
                          class="flex flex-wrap align-center justify-between yonghuhuaxiang_224_fd0_1_c2_c0_c0_c2_c0_c1_c0 bdr-8">
                          <div class="flex flex-wrap align-center justify-between  w-100">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费500-1000：</span>

                            <benben-light-text
                              class='light-text yonghuhuaxiang_147_random_fd0_1_c2_c0_c0_c2_c0_c1_c0_c0_c1 t-24 lh-20-px'
                              :field-options="payAmountUserCount1000" data_source_type="1" chart_show_type="simple-text"
                              :is_abs="false">

                            </benben-light-text>


                          </div>

                        </div>
                        <div
                          class="flex flex-wrap align-center justify-between yonghuhuaxiang_376_fd0_1_c2_c0_c0_c2_c0_c1_c1 bdr-8">
                          <div class="flex flex-wrap align-center justify-between  w-100">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费1千-5千：</span>

                            <benben-light-text
                              class='light-text yonghuhuaxiang_147_random_fd0_1_c2_c0_c0_c2_c0_c1_c0_c0_c1 t-24 lh-20-px'
                              :field-options="payAmountUserCount5000" data_source_type="1" chart_show_type="simple-text"
                              :is_abs="false">

                            </benben-light-text>


                          </div>

                        </div>

                      </div>
                      <div class="flex align-center  w-100">
                        <div
                          class="flex flex-wrap align-center justify-between yonghuhuaxiang_224_fd0_1_c2_c0_c0_c2_c0_c1_c0 bdr-8">
                          <div class="flex flex-wrap align-center justify-between  w-100">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费5千-1万：</span>

                            <benben-light-text
                              class='light-text yonghuhuaxiang_147_random_fd0_1_c2_c0_c0_c2_c0_c1_c0_c0_c1 t-24 lh-20-px'
                              :field-options="payAmountUserCount10000" data_source_type="1" chart_show_type="simple-text"
                              :is_abs="false">

                            </benben-light-text>


                          </div>

                        </div>
                        <div
                          class="flex flex-wrap align-center justify-between yonghuhuaxiang_376_fd0_1_c2_c0_c0_c2_c0_c1_c1 bdr-8">
                          <div class="flex flex-wrap align-center justify-between  w-100">
                            <span class="yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-14 t-w-5">消费1万以上：</span>

                            <benben-light-text
                              class='light-text yonghuhuaxiang_147_random_fd0_1_c2_c0_c0_c2_c0_c1_c0_c0_c1 t-24 lh-20-px'
                              :field-options="payAmountUserCountAbove" data_source_type="1" chart_show_type="simple-text"
                              :is_abs="false">

                            </benben-light-text>


                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>
                <div
                  class="flex flex-direction align-start yonghuhuaxiang_353_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto">
                  <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-20 t-w-5">
                    <span>注册方式和终端</span>

                  </div>
                  <img class='yonghuhuaxiang_661_fd0_1_c0_c0_c1_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex align-center justify-around  w-100 h-100">
                    <div
                      class="flex flex-wrap align-center justify-center yonghuhuaxiang_593_fd0_1_c2_c0_c1_c2_c0 bg-size-100">

                      <benben-pie-ring class='w-100 h-100' :field-options="userRegisterTypePie" data_source_type="1"
                                       chart_show_type="pie-ring" show_title="false" title_position="left" title_name="标题"
                                       :theme_color="theme_color_4618" :open_linkage="false" :link_chart="[]"
                                       :chart-option="chartOptions_random_3496">

                      </benben-pie-ring>

                      <span class="yonghuhuaxiang_498_fd0_1_c2_c0_c1_c2_c0_c1 f-c-fff t-16">注册方式</span>

                    </div>
                    <div
                      class="flex flex-wrap align-center justify-center yonghuhuaxiang_593_fd0_1_c2_c0_c1_c2_c0 bg-size-100">

                      <benben-pie-ring class='w-100 h-100' :field-options="userSourcePie" data_source_type="1"
                                       chart_show_type="pie-ring" show_title="false" title_position="left" title_name="标题"
                                       :theme_color="theme_color_2922" :chart-option="chartOptions_random_7714">

                      </benben-pie-ring>

                      <span class="yonghuhuaxiang_498_fd0_1_c2_c0_c1_c2_c0_c1 f-c-fff t-16">注册终端</span>

                    </div>

                  </div>

                </div>
                <div class="flex flex-direction align-start yonghuhuaxiang_138_fd0_1_c0_c0_c2 w-100 bg-size-auto">
                  <div class="flex flex-wrap align-center justify-between  w-100">
                    <div class="flex  flex-wrap align-center yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 f-c-fff t-20 t-w-5">
                      <span>会员等级分布</span>

                    </div>

                  </div>
                  <img class='yonghuhuaxiang_694_fd0_1_c0_c0_c0_c1 w-100'
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/7d6f097b9142d733270fcedbba36f6d2.png" />
                  <div class="flex  flex-wrap align-center  w-100 h-100">

                    <benben-bar-cross class='w-100 h-100' :field-options="userLevelLine" data_source_type="1"
                                      chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题"
                                      :is_morcolor="false" :theme_color="theme_color_9468" :chart-option="chartOptions_random_5517">
                    </benben-bar-cross>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>


        </div>

      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
  import {
    bigScreenMixins,
    receiveNew
  } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
  import {
    receive,
    benbenSelectDiy,
    benbenFlexNumberBox,
    scrollList,
    treeSelect,
    simpleSelect,
    multipleSelect,
    cascaderForm,
    checkboxForm,
    switchForm,
    messageReply,
    rangePicker,
    handSignature,
    mixinAddTableItem,
    editorForm,
    qiunDataCharts,
    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    getUrlKey,
    clearDataPass,
    isEmpty,
    treeEdit
  } from '@/assets/diypaaspc/diy-pass-pc.js'
  import {
    provinceForm
  } from '@/assets/diypaaspc/province_area.js'
  import request from '@/utils/request'
  import * as echarts from 'echarts'
  import 'echarts-gl'
  import 'echarts-liquidfill'
  import {
    mapdata
  } from '@/assets/diypaaspc/mapdata.js'
  import layoutBigscreen from "@/components/layoutBigscreen"
  import {
    userSex,
    userAge,
    userAddressOrder,
    userAxis,
    userSource,
    userRegisterType,
    userLevel,
    userLevelLine,
    userAddressMap,
    userBalanceCount,
    userPayAmountCount
  } from "@/api/statistics/user";
  import {goodsCatePie} from "@/api/statistics/goods";
  import {homeAllResult} from "@/api/statistics/home";
  import {orderUserCount} from "@/api/statistics/order";


  export default {
    name: 'yonghuhuaxiang',
    components: {
      layoutBigscreen
    },
    mixins: [bigScreenMixins],
    data() {
      const themeColorConfig = {
        "presetApi": {
          "getClassifyOne": "",
          "getClassifyTow": "",
          "getClassifyShop": ""
        },
        "themeType": 0,
        "themeConfig": [{
          "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777",
            "#F2CC98", "#F2CC66"
          ],
          "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE",
            "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)",
            "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)",
            "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"
          ],
          "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999",
            "#dddddd", "#1178F0", "#F02325"
          ]
        }]
      };
      receive(this);
      receiveNew(this);
      return {
        themeColorConfig,
        mapdata: mapdata,
        "isFullScreen": false,
        "big_screen_global_query": {
          "screen_global_time_range_type": "5",
          "screen_global_time_custom_time": "",
          "screen_global_dept": "",
          "screen_global_user": "",
          "diy_api_time": ""
        },
        "saizhuge_api_loaded": false,
        "school_info": {},
        "weather_data": [{
          "name": "晴",
          "code": "0",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
        }, {
          "name": "夜晚晴",
          "code": "1",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
        }, {
          "name": "晴",
          "code": "2",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
        }, {
          "name": "夜晚晴",
          "code": "3",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
        }, {
          "name": "多云",
          "code": "4",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png"
        }, {
          "name": "晴间多云",
          "code": "5",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
        }, {
          "name": "晴间多云",
          "code": "6",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
        }, {
          "name": "大部多云",
          "code": "7",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png"
        }, {
          "name": "大部多云",
          "code": "8",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png"
        }, {
          "name": "阴",
          "code": "9",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png"
        }, {
          "name": "阵雨",
          "code": "10",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png"
        }, {
          "name": "雷阵雨",
          "code": "11",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png"
        }, {
          "name": "雷阵雨伴有冰雹",
          "code": "12",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png"
        }, {
          "name": "小雨",
          "code": "13",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png"
        }, {
          "name": "中雨",
          "code": "14",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png"
        }, {
          "name": "大雨",
          "code": "15",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png"
        }, {
          "name": "暴雨",
          "code": "16",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
        }, {
          "name": "大暴雨",
          "code": "17",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png"
        }, {
          "name": "特大暴雨",
          "code": "18",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
        }, {
          "name": "冻雨",
          "code": "19",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png"
        }, {
          "name": "雨夹雪",
          "code": "20",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png"
        }, {
          "name": "阵雪",
          "code": "21",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png"
        }, {
          "name": "小雪",
          "code": "22",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png"
        }, {
          "name": "中雪",
          "code": "23",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png"
        }, {
          "name": "大雪",
          "code": "24",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png"
        }, {
          "name": "暴雪",
          "code": "25",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png"
        }, {
          "name": "浮尘",
          "code": "26",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png"
        }, {
          "name": "扬沙",
          "code": "27",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png"
        }, {
          "name": "沙尘暴",
          "code": "28",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png"
        }, {
          "name": "强沙尘暴",
          "code": "29",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png"
        }, {
          "name": "雾",
          "code": "30",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png"
        }, {
          "name": "霾",
          "code": "31",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png"
        }, {
          "name": "风",
          "code": "32",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png"
        }, {
          "name": "大风",
          "code": "33",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png"
        }, {
          "name": "飓风",
          "code": "34",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png"
        }, {
          "name": "热带风暴",
          "code": "35",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png"
        }, {
          "name": "龙卷风",
          "code": "36",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
        }, {
          "name": "冷",
          "code": "37",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
        }, {
          "name": "热",
          "code": "38",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png"
        }, {
          "name": "未知",
          "code": "99",
          "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png"
        }],
        "weather_info": {},
        "ydlist": {},
        "pass_request_data": {
          "user_type": ""
        },
        "pass_request_data1": {
          "user_type": ""
        },
        "pass_request_data2": {
          "user_type": ""
        },
        "pass_request_data3": {
          "user_type": ""
        },
        "useryd": {
          "data": [],
          "name": ""
        },
        "pass_request_data4": {
          "user_type": ""
        },
        "pass_request_data5": {
          "user_type": ""
        },
        "viewSource": "PC",
        "big_screen_global_config": {
          "is_screen_global_time": false,
          "is_screen_global_dept": false,
          "is_screen_global_user": false
        },
        "designWidth": 1920,
        "designHeight": 1080,
        "calculateStyles": {},
        "screenWidth": window.innerWidth,
        "screenHeight": window.innerHeight,
        "timerW": false,
        "timerH": false,
        "page_scale": 1,
        "theme_color_9468": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_5517": {
          "tooltip": {
            "show": true,
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": false,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "3%",
            "right": "6%",
            "bottom": "3%",
            "top": "6%",
            "containLabel": true
          },
          "barSetting": {
            "barWidth": 16,
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "label": {
              "normal": {
                "show": true,
                "position": "right",
                "fontSize": 16,
                "color": "#fff"
              }
            },
            "itemStyle": {
              "borderRadius": [5, 5, 5, 5]
            },
            "markLine": {
              "label": {
                "color": "#fff"
              },
              "symbol": "none",
              "lineStyle": {
                "type": "dashed"
              },
              "data": []
            }
          },
          "xAxis": {
            "type": "value",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            }
          },
          "yAxis": {
            "type": "category",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            }
          }
        },
        userLevelLine: {
          "yAxis": {
            "data": ["普通会员", "钻石会员", "铂金会员"]
          },
          "series": [{
            "name": 2021,
            "type": "bar",
            "data": [120, 140, 180]
          }]
        }, // 会员等级分布
        "theme_color_2922": ["#0DFBE2", "#0CAFF8", "#3E36FF", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_7714": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["20%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "#fff",
              "show": false,
              "emphasis": {
                "show": false,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "format": "{b}",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": true,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "rgba(255, 255, 255, 1)",
              "fontSize": 15
            },
            "backgroundColor": "rgba(0, 0, 0, 0.8)",
            "borderColor": "rgba(255, 0, 0, 0)"
          }
        },
        userSourcePie: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "安卓app"
            }, {
              "value": 1310,
              "name": "iosapp"
            }, {
              "value": 1234,
              "name": "小程序"
            }]
          }]
        }, // 注册终端
        "theme_color_4618": ["#03DB56", "#FF8C19", "#FBF800", "#FF5A67", "#B236FF", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_3496": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["20%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "#fff",
              "show": false,
              "emphasis": {
                "show": false,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "format": "{b}",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": true,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "rgba(255, 255, 255, 1)",
              "fontSize": 15
            },
            "backgroundColor": "rgba(0, 0, 0, 0.8)",
            "borderColor": "rgba(255, 255, 255, 0)"
          }
        },
        userRegisterTypePie: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "手机号"
            }, {
              "value": 1310,
              "name": "邮箱"
            }, {
              "value": 1200,
              "name": "其他"
            }] // 其他类型就往后加对象
          }]
        }, // 注册方式
        "payAmountUserCountAbove": {
          "data": 199
        }, // 消费1万以上
        "payAmountUserCount10000": {
          "data": 178
        }, // 消费5千-1万
        "payAmountUserCount5000": {
          "data": 880
        }, // 消费1千-5千
        "payAmountUserCount1000": {
          "data": 332
        }, // 消费500-1000
        "payAmountUserCount500": {
          "data": 33552
        }, // 消费100-500
        "payAmountUserCount100": {
          "data": 152
        }, // 消费0-100
        "theme_color_1600": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_3480": {
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": false,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "2%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            }
          },
          "barSetting": {
            "barWidth": 25,
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "label": {
              "normal": {
                "show": false,
                "position": "right",
                "fontSize": 16,
                "color": "#fff"
              }
            },
            "itemStyle": {
              "borderRadius": [5, 5, 5, 5]
            },
            "markLine": {
              "label": {
                "color": "#fff"
              },
              "symbol": "none",
              "lineStyle": {
                "type": "dashed"
              },
              "data": []
            }
          }
        },
        "field_options_906788": {
          "xAxis": {
            "data": ["重点客户", "活跃客户", "潜在客户", "回头客户"]
          },
          "series": [{
            "name": "签单数",
            "data": [150, 220, 180, 200],
            "type": "bar"
          }]
        }, // 用户标签排行
        userAddressMap: {
          "map_value": [{
            "位置": "北京市",
            "客户数": 19
          }, {
            "位置": "天津市",
            "客户数": 1
          }, {
            "位置": "河北省",
            "客户数": 36
          }, {
            "位置": "山西省",
            "客户数": 54
          }, {
            "位置": "内蒙古自治区",
            "客户数": 25
          }, {
            "位置": "辽宁省",
            "客户数": 15
          }, {
            "位置": "吉林省",
            "客户数": 27
          }, {
            "位置": "黑龙江省",
            "客户数": 33
          }, {
            "位置": "上海市",
            "客户数": 17
          }, {
            "位置": "江苏省",
            "客户数": 20
          }, {
            "位置": "浙江省",
            "客户数": 16
          }, {
            "位置": "安徽省",
            "客户数": 20
          }, {
            "位置": "福建省",
            "客户数": 19
          }, {
            "位置": "江西省",
            "客户数": 29
          }, {
            "位置": "山东省",
            "客户数": 20
          }, {
            "位置": "河南省",
            "客户数": 18
          }, {
            "位置": "湖北省",
            "客户数": 37
          }, {
            "位置": "湖南省",
            "客户数": 20
          }, {
            "位置": "广东省",
            "客户数": 35
          }, {
            "位置": "广西壮族自治区",
            "客户数": 47
          }, {
            "位置": "海南省",
            "客户数": 16
          }, {
            "位置": "重庆市",
            "客户数": 17
          }, {
            "位置": "四川省",
            "客户数": 37
          }, {
            "位置": "贵州省",
            "客户数": 20
          }, {
            "位置": "云南省",
            "客户数": 18
          }, {
            "位置": "西藏自治区",
            "客户数": 24
          }, {
            "位置": "陕西省",
            "客户数": 29
          }, {
            "位置": "甘肃省",
            "客户数": 23
          }, {
            "位置": "青海省",
            "客户数": 9
          }, {
            "位置": "宁夏回族自治区",
            "客户数": 29
          }, {
            "位置": "新疆维吾尔自治区",
            "客户数": 21
          }],
          "columns": ["位置", "客户数"],
          "position": "china",
          "region_code": "",
          "name": "地区",
          "type": "map"
        },
        "theme_color_3723": ["#11F6F2", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_3145": {
          "tooltip": {
            "show": true,
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "rgba(255, 255, 255, 1)",
              "fontSize": 15
            },
            "autoToolTip": true,
            "backgroundColor": "rgba(0, 0, 0, 0.8)",
            "borderColor": "rgba(255, 0, 0, 0)"
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": false,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "2%",
            "right": "3%",
            "bottom": "2%",
            "top": "8%",
            "containLabel": true
          },
          "yAxis": {
            "type": "value",
            "axisLine": {
              "show": false,
              "lineStyle": {
                "color": "#6E7079"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 14,
              "fontWeight": 500
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.1)"
              }
            }
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(255, 255, 255, 0.2)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "#fff",
              "fontSize": 14,
              "fontWeight": 500,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "#6E7079"
              }
            }
          },
          "seriesSetting": {
            "areaStyle": {
              "show": true
            },
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            }
          }
        },
        userAxis: {
          "xAxis": {
            "data": ["2022-10-12", "2022-10-13"]
          }, // 日期
          "series": [{
            "name": "",
            "data": [5, 10], // 数量
            "type": "line",
            "smooth": true,
            "areaStyle": []
          }]
        }, // 注册曲线
        "theme_color_1354": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_8861": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["10%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "show": false
            }
          },
          "labelSetting": {
            "label": {
              "color": "#fff",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "format": "{b}",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 17
            }
          }
        },
        "userAgePie": {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "少年"
            }, {
              "value": 1310,
              "name": "青年"
            }, {
              "value": 1234,
              "name": "中年"
            }, {
              "value": 1350,
              "name": "老年"
            }]
          }]
        }, // 年龄
        "theme_color_1601": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_6717": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["10%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "show": false
            }
          },
          "labelSetting": {
            "label": {
              "color": "#fff",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "format": "{b}",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 17
            }
          }
        },
        userSexPie: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "男"
            }, {
              "value": 1310,
              "name": "女"
            }, {
              "value": 1234,
              "name": "保密"
            }]
          }]
        }, // 性别
        userBalance500: {
          "data": 10977
        }, // 余额大于500
        userBalance100: {
          "data": 12221
        }, // 余额大于100
        userBalance50: {
          "data": 33219
        }, // 余额大于50
        userBalance0: {
          "data": "6422:1"
        }, // 余额大于0
        orderUserCount30: {
          "data": 33665
        }, // 近30天下单
        orderUserCount14: {
          "data": 19862
        }, // 近14天下单
        orderUserCount7: {
          "data": 552
        }, // 近7天下单
        orderUserCount: {
          data: 30542
        }, // 总下单用户数
        "field_options_511407": {
          "data": 5
        }, // 未成单用户数
        userCount: {
          data: 33
        }, // 用户总数
      };

    },
    filters: {},
    created() {
      if (getUrlKey('viewSource')) {
        this.viewSource = getUrlKey('viewSource');
      }
      this.userydlist()
      this.getUserSex()
      this.getUserAge()
      this.getUserLevel()
      this.getUserLevelLine()
      this.getUserAxis()
      this.getUserSource()
      this.getUserRegisterType()
      this.getUserAddressMap()
      this.getHomeAllStatistics()
      this.getOrderUserCount()
      this.getUserBalanceCount()
      this.getUserPayAmountCount()
    },
    mounted() {

      let that = this;
      window.onresize = () => {
        that.screenWidth = that.$refs.antdVue.offsetWidth
        that.screenHeight = that.$refs.antdVue.offsetHeight
        that.handleResize();
      }
      this.$nextTick(() => {
        that.handleResize();
      })
    },
    computed: {

    },
    watch: {
      screenWidth(val) {
        if (!this.timerW) {
          let that = this;
          // that.screenWidth = val;
          this.timerW = true;
          that.handleResize();
          setTimeout(function() {
            that.timerW = false;
          }, 400)
        }
      },
      screenHeight(val) {
        if (!this.timerH) {
          let that = this;
          // that.screenHeight = val;
          this.timerH = true;
          that.handleResize();
          setTimeout(function() {
            that.timerH = false;
          }, 400)
        }
      }
    },
    methods: {
      copyText,
      mixinTableItemChange,
      in_array,
      themeColorInit,
      isEmpty,
      //统一获取自定义接口
      get_diy_api_page() {

      },
      getUserSex() {
        userSex().then(response => {
          this.userSexPie={"series": [{"data": response.data}] }
        })
      },
      getUserAge() {
        userAge().then(response => {
          this.userAgePie={"series": [{"data": response.data}] }
        })
      },
      getHomeAllStatistics() {
        homeAllResult({}).then(response => {
          this.userCount = {data: response.data.userCount}
          this.orderUserCount = {data: response.data.orderCount}

        });
      },

      getUserLevel() {
        userLevel().then(response => {
          this.userLevelLine={"series": [{"data": response.data}] }
        })
      },
      getUserLevelLine() {
        userLevelLine().then(response => {
          this.userLevelLine = {
            yAxis: {
              data: response.data.xxAxis
            },
            series: [{
              name: 2021,
              data: response.data.yyAxis.userCountList || [],
              type: "bar",
            }]
          }
        })
      },

      getUserSource() {
        userSource().then(response => {
          this.userSourcePie={"series": [{"data": response.data}] }
        })
      },
      getUserRegisterType() {
        userRegisterType().then(response => {
          this.userRegisterTypePie={"series": [{"data": response.data}] }
        })
      },
      getUserAddressMap() {
        userAddressMap().then(response => {
          const mapValue = (response.data || []).map(item => {
            return {
              "位置": item.name,
              "客户数": item.value
            }
          })
          this.userAddressMap = {
            ...this.userAddressMap,
            map_value: mapValue
          }
        })
      },
      getUserBalanceCount() {
        userBalanceCount().then(response => {
          this.userBalance0 = {data: response.data.balanceUserCount0}
          this.userBalance50 = {data: response.data.balanceUserCount50}
          this.userBalance100 = {data: response.data.balanceUserCount100}
          this.userBalance500 = {data: response.data.balanceUserCount500}
        })
      },

      getUserPayAmountCount() {
        /*   /*消费0-100：payAmountUserCount100
        /*消费100-500：payAmountUserCount500
        /*消费500-1000：：payAmountUserCount1000
        /*消费1千-5千：payAmountUserCount5000
        /*消费5千-1万：payAmountUserCount10000
        /*1万以上：payAmountUserCountAbove*/
        userPayAmountCount().then(response => {
          this.payAmountUserCount100 = {data: response.data.payAmountUserCount100}
          this.payAmountUserCount500 = {data: response.data.payAmountUserCount500}
          this.payAmountUserCount1000 = {data: response.data.payAmountUserCount1000}
          this.payAmountUserCount5000 = {data: response.data.payAmountUserCount5000}
          this.payAmountUserCount10000 = {data: response.data.payAmountUserCount10000}
          this.payAmountUserCountAbove = {data: response.data.payAmountUserCountAbove}

        })
      },





      getUserAxis() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: undefined,
          endTime: undefined,
        }
        userAxis(orderAmountParam).then(response => {
          this.userAxis = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [{
              name: "",
              data: response.data.yyAxis.userCountList || [],
              type: "line",
              smooth: true,
              areaStyle: []
            }]
          }
        })
      },
      getOrderUserCount() {
        orderUserCount({}).then(response => {
          this.orderUserCount7 = {data: response.data.orderUserCount7}
          this.orderUserCount14 = {data: response.data.orderUserCount14}
          this.orderUserCount30 = {data: response.data.orderUserCount30}

        })
      },


      //用户月度累计统计
      userydlist() {
        //请求方法
        //数据验证
      },
      handleResize() {
        let that = this;
        this.$nextTick(() => {
          that.screenWidth = that.$refs.antdVue.offsetWidth
          that.screenHeight = that.$refs.antdVue.offsetHeight
          let screenWidth = that.screenWidth;
          let screenHeight = that.screenHeight;
          let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight);
          let horizontalOffset = (screenWidth - this.designWidth * scale) / 2;
          that.calculateStyles = {
            transformOrigin: 'top left',
            transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
          };
        });
      }

    }
  }
</script>
<style lang="less" scoped>
  /* External CSS is loaded in index.html to prevent style flickering */
  @import '../../assets/diypaaspc/diy-pass-big-screen.css';
  @import '../../assets/diypaaspc/library-ant-design-vue.css';

  .antdVue {
    position: relative;
    width: 100%;
    width: 1920px;
    height: 1080px;
    overflow-y: hidden;
    background-position: center center;
    background: url(https://oss.tiantianhuoke.com/m2785/background-1.png?1696487868980) no-repeat;
    background-size: 100% 100% !important;
  }

  .zoom_bg_color {
    background: rgba(179, 36, 36, 0);
  }

  #antdVue .yonghuhuaxiang_597_random_flex_0 {
    background-position: 0px 10px;
  }

  #antdVue .yonghuhuaxiang_498_fd0_1_c2_c0_c1_c2_c0_c1 {
    font-weight: 800;
    font-family: Source Han Sans SC, Source Han Sans SC;
  }

  #antdVue .yonghuhuaxiang_593_fd0_1_c2_c0_c1_c2_c0 {
    width: 162px;
    height: 162px;
    min-width: 162px;
  }

  #antdVue .yonghuhuaxiang_376_fd0_1_c2_c0_c0_c2_c0_c1_c1 {
    background: rgba(38, 95, 255, .1);
    width: 218px;
    height: 64px;
    padding: 00px 12px 00px 12px;
  }

  #antdVue .yonghuhuaxiang_147_random_fd0_1_c2_c0_c0_c2_c0_c1_c0_c0_c1 {
    font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
    color: rgba(255, 140, 25, 1);
  }

  #antdVue .yonghuhuaxiang_224_fd0_1_c2_c0_c0_c2_c0_c1_c0 {
    background: rgba(38, 95, 255, .1);
    width: 218px;
    height: 64px;
    padding: 00px 12px 00px 12px;
    margin: 0px 12px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_241_fd0_1_c2_c0_c0_c2_c0_c0_c1 {
    background: rgba(38, 95, 255, .1);
    width: 218px;
    height: 48px;
    padding: 00px 12px 00px 12px;
  }

  #antdVue .yonghuhuaxiang_561_random_fd0_1_c2_c0_c0_c2_c0_c0_c0_c1 {
    color: rgba(255, 140, 25, 1);
    line-height: 50px;
    font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
  }

  #antdVue .yonghuhuaxiang_337_fd0_1_c2_c0_c0_c2_c0_c0_c0_c0 {
    line-height: 10px;
    margin: 0px 0px -1px 0px;
  }

  #antdVue .yonghuhuaxiang_429_fd0_1_c2_c0_c0_c2_c0_c0_c0 {
    background: rgba(38, 95, 255, .1);
    width: 218px;
    height: 48px;
    padding: 00px 12px 00px 12px;
    margin: 0px 12px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_844_fd0_1_c2_c0_c0_c2_c0_c0 {
    margin: 0px 0px 12px 0px;
  }

  #antdVue .yonghuhuaxiang_765_fd0_1_c1_c0_c1_c2 {
    border-radius: 8px;
  }

  #antdVue .yonghuhuaxiang_481_fd0_1_c1_c0_c1 {
    background: rgba(38, 95, 255, .1);
    height: 280px;
    padding: 16px;
  }

  #antdVue .yonghuhuaxiang_461_random_fd0_1_c1_c0_c0_c0 {
    height: 580px;
  }

  #antdVue .yonghuhuaxiang_374_fd0_1_c1_c0_c0 {
    height: 615px;
  }

  #antdVue .yonghuhuaxiang_940_fd0_1_c1_c0 {
    height: 917px;
  }

  #antdVue .yonghuhuaxiang_138_fd0_1_c0_c0_c2 {
    background: rgba(38, 95, 255, .1);
    height: 280px;
    border-radius: 8px;
    padding: 16px;
  }

  #antdVue .yonghuhuaxiang_615_fd0_1_c0_c0_c1_c3 {
    font-weight: 800;
  }

  #antdVue .yonghuhuaxiang_978_random_fd0_1_c0_c0_c1_c2_c0 {
    height: 80%;
    --chart-title-size: 12px;
    --chart-title-top: 10px;
  }

  #antdVue .yonghuhuaxiang_180_fd0_1_c0_c0_c1_c2 {
    height: 71%;
  }

  #antdVue .yonghuhuaxiang_661_fd0_1_c0_c0_c1_c1 {
    height: 4px;
    border-radius: 0px 0px 0px 0px;
    margin: 16px 0px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_157_fd0_1_c0_c0_c1 {
    background: rgba(38, 95, 255, .1);
    height: 288px;
    border-radius: 8px;
    padding: 16px 16px 0px 16px;
  }

  #antdVue .yonghuhuaxiang_950_fd0_1_c0_c0_c0_c2_c1_c0_c4 {
    background: rgba(38, 95, 255, .1);
    height: 88px;
    border-radius: 8px;
  }

  #antdVue .yonghuhuaxiang_979_fd0_1_c0_c0_c0_c2_c1_c0_c0 {
    background: rgba(38, 95, 255, .1);
    height: 88px;
    margin: 0px 12px 0px 0px;
    border-radius: 8px;
  }

  #antdVue .yonghuhuaxiang_484_fd0_1_c0_c0_c0_c2_c0_c4 {
    background: rgba(38, 95, 255, .1);
    height: 88px;
    margin: 0px 0px 15px 0px;
    border-radius: 8px;
  }

  #antdVue .yonghuhuaxiang_248_random_fd0_1_c0_c0_c0_c2_c0_c0_c1 {
    font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
    line-height: 21px;
  }

  #antdVue .yonghuhuaxiang_324_fd0_1_c0_c0_c0_c2_c0_c0 {
    background: rgba(38, 95, 255, .1);
    height: 88px;
    margin: 0px 12px 15px 0px;
    border-radius: 8px;
  }

  #antdVue .yonghuhuaxiang_694_fd0_1_c0_c0_c0_c1 {
    height: 4px;
    border-radius: 0px 0px 0px 0px;
    margin: 16px 0px 16px 0px;
  }

  #antdVue .yonghuhuaxiang_957_fd0_1_c0_c0_c0_c0 {
    font-family: PingFang SC, PingFang SC;
  }

  #antdVue .yonghuhuaxiang_353_fd0_1_c0_c0_c0 {
    background: rgba(38, 95, 255, .1);
    height: 288px;
    border-radius: 8px;
    padding: 16px;
  }

  #antdVue .yonghuhuaxiang_517_random_fd0_0_c5 {
    width: 70px;
    height: 70px;
    --full-screen-color: rgba(255, 255, 255, 1);
    --full-screen-width: 35px;
    --full-screen-height: 35px;
    top: 28px;
    right: 100px;
    z-index: 99;
  }

  #antdVue .yonghuhuaxiang_642_random_fd0_0_c4_c1 {
    color: rgba(255, 255, 255, 1);
  }

  #antdVue .yonghuhuaxiang_424_fd0_0_c4_c0 {
    width: 32px;
    height: 32px;
    border-radius: 0px 0px 0px 0px;
    margin: 0px 8px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_868_fd0_0_c4 {
    width: 300px;
    top: 38px;
    right: 180px;
    height: 50px;
  }

  #antdVue .yonghuhuaxiang_311_fd0_0_c3 {
    width: 48px;
    height: 48px;
    border-radius: 0px 0px 0px 0px;
    margin: 0px 0px 0px 8px;
  }

  #antdVue .yonghuhuaxiang_767_fd0_0_c1 {
    width: 48px;
    height: 48px;
    margin: 0px 8px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_799_fd0_0_c0_c4 {
    font-family: Source Han Sans SC, Source Han Sans SC;
    line-height: 10px;
  }

  #antdVue .yonghuhuaxiang_991_fd0_0_c0_c3 {
    margin: 0px 0px 0px 8px;
    line-height: 10px;
  }

  #antdVue .yonghuhuaxiang_624_fd0_0_c0_c2 {
    background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #E3EAFF 49%, rgba(216, 226, 255, 0) 100%);
    width: 2px;
    height: 16px;
    margin: 0px 0px 0px 8px;
  }

  #antdVue .yonghuhuaxiang_468_fd0_0_c0_c1 {
    margin: 0px 0px 0px 8px;
  }

  #antdVue .yonghuhuaxiang_314_fd0_0_c0_c0 {
    width: 32px;
    height: 32px;
    border-radius: 0px 0px 0px 0px;
  }

  #antdVue .yonghuhuaxiang_447_fd0_0_c0 {
    top: 38px;
    left: 82px;
    height: 50px;
  }

  #antdVue .yonghuhuaxiang_271_fd0_0 {
    background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png) no-repeat;
    font-size: 48px;
    height: 135px;
    font-weight: 800;
  }

  .zoom_bg_color {
    background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240218/28580720a4073072604131817b3e36d2.png) center / 100% 100% no-repeat !important;
    background-size: 100% 100% !important;
    overflow: hidden;
  }

  #map {
    height: 100%
  }
</style>